export default "__VITE_ASSET__Z$pkC4Pi__";